import { render, staticRenderFns } from "./Performers.vue?vue&type=template&id=64970b6c&"
import script from "./Performers.vue?vue&type=script&lang=js&"
export * from "./Performers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports